import { createApi } from '@reduxjs/toolkit/query/react'
import { NetWork } from '../../../common/apiKey'
import { DELETE, GET, PATCH, POST, PUT } from '../../../common/contants'
import { axiosBaseQuery } from '../../baseQuery'

export const offerToPayApi = createApi({
  reducerPath: 'offerToPayApi',
  baseQuery: axiosBaseQuery,
  tagTypes: ['OfferToPay', 'DetailCus'],
  endpoints: (builder) => ({
    getListOfferToPay: builder.query({
      query: (params) => ({
        url: NetWork.offerToPay,
        method: GET,
        params: params
      }),
      // providesTags: (result: ReponseData2<{ rows: OfferToPayType[] }>) =>
      //   result ? [{ type: 'OfferToPay', id: 'LIST' }] : [])
      providesTags: (result) => (result ? [{ type: 'OfferToPay', id: 'LIST' }] : [])
    }),
    getOfferToPayById: builder.query({
      query: (params: { offerToPayId: number }) => ({
        url: NetWork.offerToPayId(params.offerToPayId),
        method: GET
      }),
      providesTags: (result) => (result ? [{ type: 'DetailCus', id: 'DETAIL' }] : [])
    }),
    addOfferToPay: builder.mutation({
      query: (data) => ({
        url: NetWork.offerToPay,
        method: POST,
        data: data
      }),
      invalidatesTags: [{ type: 'OfferToPay', id: 'LIST' }]
    }),
    updateOfferToPay: builder.mutation({
      query: (data) => ({
        url: NetWork.offerToPayId(data.id),
        method: PUT,
        data: data
      }),
      invalidatesTags: [{ type: 'OfferToPay', id: 'LIST' }]
    }),
    deleteOfferToPay: builder.mutation({
      query: (data: { ids: Array<number | string> }) => ({
        url: NetWork.offerToPay,
        method: DELETE,
        data: data
        // invalidatesTags: [{ type: 'OfferToPay', id: 'LIST' }] // Vô hiệu hóa tag 'OfferToPay' với id 'LIST' để gọi lại getListOfferToPay
      }),
      invalidatesTags: [{ type: 'OfferToPay', id: 'LIST' }]
    }),
    changeStatusOfferToPay: builder.mutation({
      query: (data: { offerToPayId: number; params: { isActive: boolean } }) => ({
        url: NetWork.offerToPayId(data.offerToPayId),
        method: PATCH,
        params: data.params
      })
    }),
    updateStatusApprovalOfferToPay: builder.mutation({
      query: (data: { id: number; params: { statusApproval: string; reasonCancel?: string } }) => ({
        url: NetWork.offerToPayApproval(data.id),
        method: PUT,
        params: data.params
      }),
      invalidatesTags: [{ type: 'OfferToPay', id: 'LIST' }]
    })
  })
})

// Export hooks for usage in functional components
export const {
  useGetListOfferToPayQuery,
  useDeleteOfferToPayMutation,
  useAddOfferToPayMutation,
  useGetOfferToPayByIdQuery,
  useUpdateOfferToPayMutation,
  useChangeStatusOfferToPayMutation,
  useUpdateStatusApprovalOfferToPayMutation
} = offerToPayApi
